module.exports = __webpack_public_path__ + "Poppins-Thin.362d5991e980e0b2656c.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-Thin.woff
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-Thin.woff
// module chunks = styles